<!-- Begin page -->
<div id="wrapper">

  <!-- Top Bar Start -->
  <div class="topbar">
    <!-- LOGO -->
    <div class="topbar-left">
      <a routerLink="/admin/sucursales" class="logo">
        <span class="logo-light">
          <i class="mdi mdi-camera-control"></i> {{nameApp}}
        </span>
        <span class="logo-sm">
          <i class="mdi mdi-camera-control"></i>
        </span>
      </a>
    </div>

    <nav class="navbar-custom">
      <ul class="navbar-right list-inline float-right mb-0">
        <!-- <li class="dropdown notification-list list-inline-item">
          <div class="dropdown notification-list nav-pro-img">
            <a class="dropdown-toggle nav-link arrow-none nav-user" data-toggle="dropdown" href="#" role="button"
              aria-haspopup="false" aria-expanded="false">
            </a>
            <div class="dropdown-menu dropdown-menu-right profile-dropdown ">
              <a class="dropdown-item" href="#"><i class="mdi mdi-account-circle"></i> Profile</a>
              <a class="dropdown-item" href="#"><i class="mdi mdi-wallet"></i> My Wallet</a>
              <a class="dropdown-item d-block" href="#"><span class="badge badge-success float-right">11</span><i
                  class="mdi mdi-settings"></i> Settings</a>
              <a class="dropdown-item" href="#"><i class="mdi mdi-lock-open-outline"></i> Lock screen</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-danger" href="#"><i class="mdi mdi-power text-danger"></i> Logout</a>
            </div>
          </div>
        </li> -->
        <li class="dropdown notification-list list-inline-item">
          <div class="dropdown notification-list nav-pro-img">
            <a class="dropdown-toggle nav-link arrow-none nav-user pointer" data-toggle="dropdown" role="button"
              aria-haspopup="false" aria-expanded="false">
              <span class="m-r-10 f-s-12 bold">{{user.username}}</span>
              <img src="/img/user_default.png" alt="user" class="rounded-circle">
            </a>
            <div class="dropdown-menu dropdown-menu-right profile-dropdown">
              <!-- item-->
              <a class="dropdown-item pointer m-b-5"><i class="fas fa-user-tie"></i> Mi cuenta</a>
              <a class="dropdown-item" routerLink="/admin/sucursales"><i class="fas fa-home"></i>Sucursales</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-danger pointer" (click)="logout()"><i class="mdi mdi-power text-danger"></i>
                Cerrar Sesión
              </a>
            </div>
          </div>
        </li>

      </ul>
      <ul class="list-inline menu-left mb-0">
        <li class="float-left">
          <button class="button-menu-mobile open-left waves-effect">
            <i class="mdi mdi-menu"></i>
          </button>
        </li>
        <li class="d-md-inline-block p-t-14 hide-xs">
          
          <app-navtop-branchoffice-information></app-navtop-branchoffice-information>
        </li>
      </ul>
    </nav>

  </div>
  <!-- Top Bar End -->

  <!-- ========== Left Sidebar Start ========== -->
  <div class="left side-menu">
    <div class="slimscroll-menu" id="remove-scroll">

      <!--- Sidemenu -->
      <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <ul class="metismenu" id="side-menu">
          <li class="menu-title">Menu</li>
          <ng-container *ngFor="let module of modules">
            <ng-container *ngIf="module.ui_sref =='#'">
              <li id="{{module.father_url}}">
                <a class="waves-effect">
                  <i class="{{module.icon}}"></i>
                  <span>{{module.name}}
                    <span class="float-right menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
                  </span>
                </a>
                <ul class="submenu mm-collapse parent_{{module.father_url}}">
                  <li *ngFor="let child of module.childsmodule" class="links-menu" id="module_{{child.module}}">
                    <a (click)="childLoadMenu(branchofficeSlug,'/', child.ui_sref)"
                      routerLink="/{{branchofficeSlug}}/{{child.ui_sref}}">{{child.name}}</a>
                  </li>
                </ul>
              </li>
            </ng-container>
            <ng-container *ngIf="module.father_id == null && module.ui_sref !='#'">
              <li id="{{module.father_url}}">
                <a (click)="loadParent(branchofficeSlug,'/', module.ui_sref)"
                  routerLink="/{{branchofficeSlug}}/{{module.ui_sref}}" class="waves-effect">
                  <i class="{{module.icon}}"></i>
                  <span>{{module.name}}</span>
                </a>
              </li>
            </ng-container>
          </ng-container>
        </ul>

      </div>
      <!-- Sidebar -->
      <div class="clearfix"></div>

    </div>
    <!-- Sidebar -left -->

  </div>
  <!-- Left Sidebar End -->

  <!-- ============================================================== -->
  <!-- Start right Content here -->
  <!-- ============================================================== -->
  <div class="content-page">
    <!-- Start content -->
    <app-loading></app-loading>
    <div class="content position-relative">
      <div class="container-fluid p-0">
        <div class="content__body p-l-10 p-r-10" id="content__body">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <!-- content -->
  </div>
  <!-- ============================================================== -->
  <!-- End Right content here -->
  <!-- ============================================================== -->

</div>
<!-- END wrapper -->
